import { formatClientDisplayName } from '@/utils/clientDisplayName'

export default {
  methods: {
    formatClientDisplayName,
  },
}
